<template>
	<div class="headerview">
		<div class="l_a">
			<div class="blacka w13 f-row-b">
				<div class="f-row-l">
					<span @click="tobasic(0)">队章</span>
					<span @click="tobasic(1)">队旗</span>
					<span @click="tobasic(2)">队徽</span>
					<span @click="tobasic(3)">队歌</span>
				</div>
				<div>
				</div>
			</div>
		</div>
		<div class="imgbg"></div>

		<div class="l_b">
			<div class="blackb w13">
				<div
				v-for="(items,index) in topList" :key="index"
				@mouseover="mouseOver(index)" @mouseleave="mouseLeave()">
				    <div :class="signtab == index?'signle_cur':'signle'" @click="tonav(items,index)">{{items.title}}</div>

					<div class="linecon"></div>
					<div class="soncon" v-if="mouseIndex == index">
						<div class="col" v-for="(item,y) in items.list" :key="y"
						@click="tosonnav(item,y)">
							<div :class="signtab == index && sonsigntab == y?'name_cur':'name'">{{item.name}}</div>
						</div>
					</div>

				</div>
			</div>


		</div>

	</div>

</template>

<script>

export default {
  components:{},
  props:["cur"],
  data: function() {
    return {
		signtab:0,
		topList:[{
			title:"首页",
			pathurl:"/",
			list:[]
		},{
		    title:"少先队基本知识",
			pathurl:"/basicknowledge?type=0",
			list:[
				{name:"队章",pathurl:"/basicknowledge?type=0"},
				{name:"队旗",pathurl:"/basicknowledge?type=1"},
				{name:"队徽",pathurl:"/basicknowledge?type=2"},
				{name:"队歌",pathurl:"/basicknowledge?type=3"},
			]
		},{
			title:"队情资讯",
			pathurl:"/teaminform?type=1",
			list:[
				{name:"重要资讯",pathurl:"/teaminform?type=1"},
				{name:"最新通知",pathurl:"/teaminform?type=2"},
				{name:"各地动态",pathurl:"/teaminform?type=3"},
			]
		},{
			title:"专题活动",
			pathurl:"/themactivities",
			list:[]
		},{
			title:"学习资料",
			pathurl:"/studytrain",
			list:[
				{name:"文件库",pathurl:"/filelibrary"},
				{name:"学习资料",pathurl:"/learnmaterials"},
				{name:"网络课堂",pathurl:"/networkroom"},
				{name:"文化产品",pathurl:"/culturalpro?type=0"},
				{name:"标准队课",pathurl:"/excellentcases"},
				{name:"证书模板",pathurl:"/downloadlist?signtype=6"},
			]
		},{
			title:"光荣榜",
			// title:"红领巾通讯社",
			pathurl:"/gloriousedit",
			// list:[
			// 	{name:"光荣榜",pathurl:"/gloriousedit"},
			// 	{name:"社会情报站",pathurl:"/socialintell"},
			// ]
		},
		// {
		// 	title:"下载专区",
		// 	pathurl:"/downloadzone",
		// 	list:[]
		// }
		],

		mouseIndex:-1,
	    sonsigntab:-1,

    };
  },

  mounted() {
		this.signtab = this.cur
		this.sonsigntab = sessionStorage.getItem("sonsigntab")
  },

  methods: {
		tonav(item,index){
			// this.$router.go(0)
			// console.log("当前路由："+this.$route.path
			if(this.$route.fullPath == item.pathurl){
				this.$router.go(0)
			}else{
				this.$router.push({ path: item.pathurl })
				this.sonsigntab = 0
			}
			this.signtab = index

			if(index == 1 || index == 2 || index == 5){
				sessionStorage.setItem("sonsigntab", 0)
			}else{
				sessionStorage.setItem("sonsigntab", null)
			}

		},

		tosonnav(item,index){
			// this.$router.go(0)
			// console.log("当前路由："+this.$route.path)
			// console.log("当前路由参数："+this.$route.query.type)
			// var list = item.pathurl.split('?')
			// if(this.$route.path == list[0]){
			// 	if(this.$route.query.type == list[1]){
			// 		this.$router.go(0)
			// 	}
			// }

			this.$router.push({ path: item.pathurl })
			this.sonsigntab = index
			sessionStorage.setItem("sonsigntab", index)
		},

		tobasic(type){
			this.$router.push({ path: '/basicknowledge?type='+type })
			this.sonsigntab = index
			sessionStorage.setItem("sonsigntab", index)
		},

		//鼠标移入移出
		mouseOver(index){
			this.mouseIndex = index;
		},
		mouseLeave(){
			this.mouseIndex = -1;
		},

  },


};
</script>

<style scoped=" scoped" lang="scss">
@import url('./../static/css/base.scss');
.headerview{
	position: relative;
    z-index: 100;
	.l_a{
		height: 53px;
		width: 100%;
		background: #E61F26;
		opacity: 0.77;
		display: flex;
		justify-content: center;
		.blacka{
			height: 53px;
			line-height: 53px;
			font-size: 16px;
			font-weight: 400;
			color: #FFFFFF;
			span{
				cursor: pointer;
				margin-right: 20px;
			}
		}
	}

	.imgbg{
		height: 366px;
		width: 100%;
		background: url(../static/img/topbg@2x.png) no-repeat center / auto 100%;
		background-size: cover;
	}

	.l_b{
		margin-top: -66px;
		width: 100%;
		height: 66px;
		background: #E61F26;
		display: flex;
		justify-content: center;
		.blackb{
			height: 66px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;
			.signle_cur,.signle{
				min-width: 120px;
			}
			.signle_cur{
				font-size: 20px;
				color: #FFFFFF;
				text-align: center;
				height: 50px;
				line-height: 50px;
				background: #FA9E1E;
				border-radius: 3px;
				padding-left: 20px;
				padding-right: 20px;
			}
			.signle{
				font-size:20px;
				color: #FFFFFF;
				text-align: center;
				height: 50px;
				line-height: 50px;
			}

			.linecon{
				position: absolute;
				z-index: 10;
				height: 20px;
				padding-left: 20px;
				padding-right: 20px;
				width: 120px;
				background-color: rgba(0, 0, 0, 0);
			}
			.soncon{
				position: absolute;
				z-index: 10;
				margin-top: 20px;
				background: #FA9E1E;
				border-radius: 3px;
				padding-left: 20px;
				padding-right: 20px;
				width: 120px;
				.col{
					height: 50px;
					display: flex;
					flex-direction: column;
					align-items: center;
					.name_cur{
						font-size: 18px;
						color: #FFFFFF;
						border-bottom: 1px solid #FFFFFF;
						min-width: 20px;
						line-height: 40px;
					}
					.name{
						font-size:18px;
						color: #FFFFFF;
						min-width: 20px;
						line-height: 40px;
					}
				}
				.col:hover .name{
					border-bottom: 1px solid #FFFFFF;
				}

			}

		}


	}




}

</style>
